module.exports = __webpack_public_path__ + "img/swap.a2c04b7e.svg";